import isLocalhost from './is-localhost';
import { productionSnippet, sandboxSnippet } from './forter-snippets';


export function loadForter(session) {
  let scriptSnippet = sandboxSnippet;
  if (
    process.env.NODE_ENV === 'production'
    // Check that we are not in localhost to avoid sending data to
    // production account from CI servers or when testing the
    // production build locally.
    && !isLocalhost(window.location.hostname)
    && session.environment === 'production'
  ) {
    scriptSnippet = productionSnippet;
  }

  const scriptElement = document.createElement('script');
  scriptElement.appendChild(document.createTextNode(scriptSnippet));
  document.body.appendChild(scriptElement);
}

export const listenForForterToken = (
) => {
  document.addEventListener('ftr:tokenReady', () => {
    // TODO
    // send token to backend
    // const token = evt.detail;
  });
};



// WEBPACK FOOTER //
// ./app/utilities/get-forter.js